var render, staticRenderFns
import script from "./RodeColumnComponent.vue?vue&type=script&lang=js&"
export * from "./RodeColumnComponent.vue?vue&type=script&lang=js&"
import style0 from "./RodeColumnComponent.vue?vue&type=style&index=0&id=fd68c874&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd68c874",
  null
  
)

export default component.exports